// components/sales/Header.jsx
import React from 'react';
import { StandardHeader } from '../../common/StandardHeader';

export const Header = ({ 
  loading, 
  lastUpdated,
  dateRange,
  onDateRangeChange,
  onRefresh,  // ✅ Accept from parent
  isRefreshing,  // ✅ Accept from parent (optional)
}) => {
  return (
    <StandardHeader
      title="Marketing Dashboard"
      subtitle="Comprehensive analytics for Marketing"
      loading={loading}
      lastUpdated={lastUpdated}
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      onRefresh={onRefresh}  // ✅ Pass parent's handler directly
      isRefreshing={isRefreshing}
      yearsOnly={true}
    />
  );
};